import React, { useEffect, useState } from "react";

const Loader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.classList.add("loading");

    const timer = setTimeout(() => {
      setLoading(false);
      document.body.classList.remove("loading");
    }, 1500); 

    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <div className="page-loader">
      <div className="loader-core">
        <img
          src="/zarkit-z.png"
          alt="Zarkit logo"
          className="loader-logo"
        />
        <div className="loader-line loader-line-a"></div>
        <div className="loader-line loader-line-b"></div>
      </div>

      <p className="loader-title">Zarkit</p>
      <p className="loader-subtitle">
        Powered by Zarkit Group. Moving goods across the city.
      </p>
    </div>
  );
};

export default Loader;